import { render, staticRenderFns } from "./CharacterMove.vue?vue&type=template&id=39a13890&"
import script from "./CharacterMove.vue?vue&type=script&lang=js&"
export * from "./CharacterMove.vue?vue&type=script&lang=js&"
import style0 from "./CharacterMove.vue?vue&type=style&index=0&id=39a13890&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports